/* Keep the basket true after Back/Forward (the thread, 30 Oct 2026).
   Found 30 Oct on live and the remake: add an item, tap Back, open the basket -> "Your basket is empty" while the
   cart holds the item, because the browser shows the earlier page from its back-forward cache. On a history
   visit this asks Shopify for the cart and the basket sections and hands them to the theme's own cart update,
   so the drawer, the basket page and the header count all redraw with the stock code. */
(() => {
  const historyVisit = (event) =>
    event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';

  const refresh = async () => {
    if (!window.FoxTheme?.pubsub || !FoxTheme.routes?.cart_url) return;
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    const ids = [...new Set(sections)].filter(Boolean);
    try {
      const cart = await (await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() })).json();
      if (ids.length) {
        // 1 Nov (swarm fix batch 4, T6): keep the page's query (view=doe, q=) so the redraw stays in this brand's look.
        const params = new URLSearchParams(window.location.search);
        params.set('sections', ids.join(','));
        const url = `${window.location.pathname}?${params.toString()}`;
        cart.sections = await (await fetch(url, { credentials: 'same-origin' })).json();
      }
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart, source: 'rn-cart-fresh' });
    } catch (e) {
      console.warn('rn-cart-fresh', e);
    }
  };

  window.addEventListener('pageshow', (event) => {
    if (historyVisit(event)) refresh();
  });
})();
